import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function AIDisclaimerPage(): React.JSX.Element {
    return (
        <ComplianceDocument
            slug="ai-disclaimer"
            title="AI Disclaimer (Non-Medical Use Notice)"
            description={
                <span>
                    This AI Disclaimer explains how <strong>kivo.skin</strong> uses artificial intelligence
                    and clarifies that our service is not a medical device and does not provide medical advice.
                </span>
            }
        />
    );
}
